import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import apis from '@/apis/caseManage';
import scheduleManageApi from '@/apis/scheduleManage';
var timeout;

var CaseManage = /*#__PURE__*/function (_Vue) {
  _inherits(CaseManage, _Vue);

  var _super = _createSuper(CaseManage);

  function CaseManage() {
    var _this;

    _classCallCheck(this, CaseManage);

    _this = _super.apply(this, arguments);
    _this.keyword = '';
    _this.sort = null;
    return _this;
  }

  _createClass(CaseManage, [{
    key: "handleCreateCase",
    value: function handleCreateCase() {
      this.$router.push({
        name: 'CaseCreate'
      });
    }
  }, {
    key: "handleSearchChange",
    value: function handleSearchChange(e) {
      var _this2 = this;

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        _this2.$refs.pagedTable.reload({
          sortBy: 'caseNoAll',
          order: _this2.sort,
          keyWord: _this2.keyword
        });
      }, 1000);
    }
  }, {
    key: "handleSortChange",
    value: function handleSortChange(e) {
      var table = this.$refs.pagedTable;
      this.sort = e.order && (e.order === 'ascending' ? 'asc' : 'desc');
      table.reload({
        sortBy: 'caseNoAll',
        order: this.sort,
        keyWord: this.keyword
      });
    }
  }, {
    key: "handleToDetail",
    value: function handleToDetail(item) {
      this.$router.push({
        name: 'CaseInfo',
        params: {
          id: item.caseIndexCode
        }
      });
    }
  }, {
    key: "handleToEdit",
    value: function handleToEdit(item) {
      this.$router.push({
        name: 'CaseUpdate',
        params: {
          id: item.caseIndexCode
        }
      });
    }
  }, {
    key: "handleToSchedule",
    value: function handleToSchedule(item) {
      var _this3 = this;

      if (item.status === 'unPlan') {
        this.$router.push("/index/scheduleCreate/".concat(item.caseIndexCode));
      } else {
        apis.nearestSchedule({
          caseIndexCode: item.caseIndexCode
        }).then(function (res) {
          _this3.$router.push("/index/scheduleUpdate/".concat(res.data.scheduleId));
        }).catch(function (_) {});
      }
    }
  }, {
    key: "handleBackToTrial",
    value: function handleBackToTrial(item) {
      var _this4 = this;

      this.$confirm('退回重审后需要重新排期，确定退回吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question',
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    apis.changeTrialStatus({
                      caseId: item.caseId
                    }).then(function () {
                      _this4.$message({
                        type: 'success',
                        message: '退回重审成功!'
                      });

                      _this4.$refs.pagedTable.reload();
                    }).catch(function (_) {});

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }

          return onConfirm;
        }(),
        onCancel: function onCancel() {}
      });
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(item) {
      var _this5 = this;

      this.$confirm('此操作将删除该案件, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(function (action) {
        if (item.status === 'unPlan') {
          apis.deleteCase({
            caseIndexCode: item.caseId
          }).then(function (_) {
            _this5.$message.success('删除案件成功');

            _this5.$refs.pagedTable.reload();
          }).catch(function (_) {});
        } else {
          apis.nearestSchedule({
            caseIndexCode: item.caseIndexCode
          }).then(function (res) {
            scheduleManageApi.deleteScheduleAndCase({
              caseId: item.caseId,
              scheduleId: res.data.scheduleId
            }).then(function (_) {
              _this5.$message.success('删除案件成功');

              _this5.$refs.pagedTable.reload();
            }).catch(function (_) {});
          }).catch(function () {});
        }
      }).catch(function () {});
    }
  }, {
    key: "tableFetchWithReload",
    value: function tableFetchWithReload(url, pageSize, pageNo) {
      var reloadOpt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        sortBy: 'caseNoAll',
        order: this.sort,
        keyWord: this.keyword
      };
      var params = Object.assign({
        pageSize: pageSize,
        pageNo: pageNo
      }, reloadOpt); // params.pageNo = reloadOpt.initPage ? 1 : pageNo
      // if (params.initPage) delete params.initPage

      return apis.getCase(params).then(function (res) {
        console.log('res', res);
        return res.data;
      }).catch(function (_) {});
    }
  }, {
    key: "isActive",
    value: function isActive() {
      console.log('激活');
      this.$refs.pagedTable.reload({
        sortBy: 'caseNoAll',
        order: this.sort,
        keyWord: this.keyword
      });
    }
  }, {
    key: "activated",
    value: function activated() {
      console.log('activated');
      this.$refs.pagedTable.reload({
        sortBy: 'caseNoAll',
        order: this.sort,
        keyWord: this.keyword
      });
    } // mounted() {
    //   console.log('mounted');
    //   (this.$refs.pagedTable as any).reload({ sortBy: 'caseNoAll', order: this.sort, keyWord: this.keyword })
    // }

  }, {
    key: "beforeRouteUpdate",
    value: function beforeRouteUpdate(to, from, next) {
      console.log('路由变化', to, from, next);
    }
  }, {
    key: "userId",
    get: function get() {
      return this.$store.getters.userInfo.userId;
    }
  }]);

  return CaseManage;
}(Vue);

CaseManage = __decorate([Component], CaseManage);
export default CaseManage;